import React from 'react'
import {
  BookOpen,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
export default function MyBetsContent() {
  return (
    <div className="px-3 pt-3">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="flex items-center mb-4">
          <BookOpen className="w-6 h-6 text-orange-500 mr-2" />
          <h1 className="text-white text-xl font-bold">Mis Apuestas</h1>
        </div>

        <div className="bg-gray-800 rounded-lg p-4 mb-4">
          <div className="flex space-x-2 mb-3">
            <motion.button
              className="bg-orange-500 text-white rounded-full px-4 py-1 text-sm font-medium"
              whileTap={{ scale: 0.95 }}
            >
              Activas
            </motion.button>
            <motion.button
              className="bg-gray-700 text-gray-300 rounded-full px-4 py-1 text-sm"
              whileTap={{ scale: 0.95 }}
            >
              Historial
            </motion.button>
            <motion.button
              className="bg-gray-700 text-gray-300 rounded-full px-4 py-1 text-sm"
              whileTap={{ scale: 0.95 }}
            >
              Liquidadas
            </motion.button>
          </div>
        </div>

        <div className="space-y-3 mb-6">
          {[1, 2].map((item) => (
            <motion.div
              key={item}
              className="bg-gray-800 rounded-lg p-3 shadow-md"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <div className="flex justify-between mb-2">
                <span className="text-xs text-gray-400">
                  Parlay • 3 Selecciones
                </span>
                <span className="text-xs text-orange-500 font-medium">
                  En curso
                </span>
              </div>
              <div className="border-b border-gray-700 pb-2 mb-2">
                <div className="flex justify-between items-center">
                  <span className="text-xs text-gray-400">River vs Boca</span>
                  <span className="text-xs text-white">Victoria Local</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-xs text-gray-400">
                    Barcelona vs Real Madrid
                  </span>
                  <span className="text-xs text-white">Más de 2.5 Goles</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-xs text-gray-400">PSG vs Bayern</span>
                  <span className="text-xs text-white">Ambos marcan</span>
                </div>
              </div>
              <div className="flex justify-between items-center">
                <div>
                  <span className="text-xs text-gray-400">Apuesta:</span>
                  <span className="text-sm text-white ml-1">$50</span>
                </div>
                <div>
                  <span className="text-xs text-gray-400">
                    Ganancia potencial:
                  </span>
                  <span className="text-sm text-green-500 ml-1">$312.50</span>
                </div>
              </div>
            </motion.div>
          ))}

          <div className="text-center py-4">
            <span className="text-gray-400 text-sm">
              No hay más apuestas activas
            </span>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
